import React from "react";
import PropTypes from "prop-types";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "chart.js/auto";

const BarGraph = ({
  graphData,
  labels,
  backgroundColor = ["#000000", "#00AAD2"],
}) => {
  const options = {
    layout: {
      padding: {
        top: 20,
      },
    },
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          drawBorder: false,
          borderColor: "green",
          borderWidth: 5,
          display: false,
        },
        ticks: {
          display: false,
          font: {
            family: "HyundaiSansText",
            size: "13px",
          },
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#000000",
          font: {
            family: "toyota_typeregular",
            size: "13px",
          },
        },
      },
    },
    responsive: true,
    plugins: {
      datalabels: {
        font: {
          size: 18,
          family: "toyota_typeregular",
          weight: "bold",
        },
        color: "#000",
        display: true,
        anchor: "end",
        align: "end",
        offset: 0,
        useHtml: true,
        formatter: function (value, ctx) {
          return Number(value.toFixed(0)).toLocaleString("en-US") + " lbs. CO₂";
        },
      },
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.formattedValue;
            return label + " lbs. CO₂";
          },
          title: ([{ label }]) => (label ? label.replace(",", " ") : ""),
        },
      },
      // title: {
      //     display: true,
      //     position: "top",
      //     text: header,
      // },
    },
  };

  // Specific Change for Label
  labels.map((label, index) => {
    if (label === "2023 TUCSON Plug-In Hybrid") {
      labels[index] = ["2023 TUCSON", "Plug-In Hybrid"];
    }

    if (label === "2023 KONA Electric") {
      labels[index] = ["2023 KONA", "Electric"];
    }

    if (label === "2023 IONIQ 5") {
      labels[index] = ["2023", "IONIQ 5"];
    }

    if (label === "2023 IONIQ 6") {
      labels[index] = ["2023", "IONIQ 6"];
    }

    if (label === "2022 IONIQ Plug-in Hybrid") {
      labels[index] = ["2022 IONIQ", "Plug-in Hybrid"];
    }

    if (label === "2023 SANTA FE Plug-in Hybrid") {
      labels[index] = ["2023 SANTA FE", "Plug-in Hybrid"];
    }

    return "";
  });

  const data = {
    labels,
    datasets: [
      {
        // label: 'Dataset 1',
        data: graphData,
        backgroundColor: backgroundColor,
      },
    ],
  };

  return (
       <div className="emissions-bar-graph-container">
              <div className="emissions-bar-graph">
                     <Bar options={options} data={data} plugins={[ChartDataLabels]} aria-label="Bar Graph"/>
                     <p id="barGraphDescription" hidden>Bar graph</p>
                     <p>Make a difference with <strong>Clean Assist</strong>. Get 100% of your charge matched with renewable electricity. <a target="_blank" rel="noopener noreferrer" href="https://www.toyota.com/owners/clean-assist/">Learn more</a></p>
              </div>
       </div>
  );
};
export default BarGraph;

BarGraph.propTypes = {
  header: PropTypes.string,
  subHeader: PropTypes.string,
  graphData: PropTypes.array,
  labels: PropTypes.array,
  backgroundColors: PropTypes.array,
};
